// extracted by mini-css-extract-plugin
export default {"content":"unblock-member_content__xzAba","tip":"unblock-member_tip__LgWjh","text-bold":"unblock-member_text-bold__jjAZu"};